
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/content",
      function () {
        return require("private-next-pages/solutions/content.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/content"])
      });
    }
  